import React, { Fragment, useEffect, useReducer, useRef } from "react";
import { useDebouncedCallback } from "use-debounce";
import { ToastContainer, toast, Slide } from "react-toastify";
import { useAuth0 } from "@auth0/auth0-react";

import axios from "axios";
import ai from "../../helpers/axios";
import columns from "./aircraft-columns";
import TableBulkActions from "../table-bulk-actions";
import Search from "../search";

import DataTableServerPagination from "../data-table-server-pagination";

import PageHeaderRowSearch from "../shared/page-header-row-search";

const reducer = (state, action) => {
  switch (action.type) {
    case "search": {
      return {
        ...state,
        query: action.query,
      };
    }
    case "dataBeganDownloading": {
      return {
        ...state,
        loading: action.payload.loadingStatus,
      };
    }
    case "rowsDeleted": {
      return {
        ...state,
        clearSelectedRows: !state.clearSelectedRows,
        selectedRows: [],
      };
    }
    case "rowSelection": {
      return {
        ...state,
        selectedRows: action.payload.selectedRows,
        allSelected: action.payload.allSelected,
      };
    }
    case "dataDownloaded": {
      console.log(action.payload);
      return {
        ...state,
        aircrafts: {
          data: action.payload.data.aircraft,
        },
        loading: false,
        totalLength: action.payload.data.countTotal,
        aircraftTypes: action.payload.data.aircraftTypes,
      };
    }
    case "pageChanged": {
      return {
        ...state,
        currentPage: action.payload.page,
      };
    }
    case "rowsPerPageChanged": {
      return {
        ...state,
        countPerPage: action.payload.currentRowsPerPage,
      };
    }
    default:
      break;
  }
  return state;
};

const AircraftsContent = () => {
  const initialState = {
    aircrafts: {
      data: [],
    },
    loading: true,
    countPerPage: 25,
    currentPage: 1,
    query: "",
    selectedRows: [],
    allSelected: false,
    tagFilters: [],
    totalLength: null,
    clearSelectedRows: false,
    aircraftTypes: [],
  };

  const { getAccessTokenSilently, loginWithRedirect } = useAuth0();

  const [state, dispatch] = useReducer(reducer, initialState);

  console.log(state);

  const abortControllerRef = useRef(null);

  const getData = async (dbQuery, loadSilently) => {
    abortControllerRef.current?.abort();
    abortControllerRef.current = new AbortController();
    const signal = abortControllerRef.current.signal;

    let loadingStatus = !loadSilently;

    dispatch({ type: "dataBeganDownloading", payload: { loadingStatus } });

    try {
      const token = await getAccessTokenSilently().catch((e) => {
        console.error(e);
        return loginWithRedirect();
      });

      // let updatedData = data.aircraft.map((aircraft) => {
      //   data.aircraftTypes.forEach((aircraftType) => {
      //     if (aircraft.aircraftTypeId === aircraftType._id) {
      //       return (aircraft.aircraftClass = aircraftType.name);
      //     }
      //   });
      //   return aircraft;
      // });

      // console.log("updatedData", updatedData);

      let { data } = await ai.auth(token).get(`/api/aircrafts/list`, {
        signal,
        params: {
          query: dbQuery,
          page: state.currentPage,
          countPerPage: state.countPerPage,
        },
      });

      dispatch({
        type: "dataDownloaded",
        payload: {
          data,
        },
      });
    } catch (error) {
      if (axios.isCancel(error)) return;
      console.error(error);
    }
  };

  useEffect(() => {
    getData("");
    document.title = "Aircraft | evoJets HQ";
  }, [state.currentPage, state.countPerPage]);

  const handlePageChange = (page, totalRows) => {
    dispatch({
      type: "pageChanged",
      payload: {
        page,
        totalRows,
      },
    });
  };

  const handleRowsPerPageChange = (currentRowsPerPage, currentPage) => {
    dispatch({
      type: "rowsPerPageChanged",
      payload: {
        currentRowsPerPage,
        currentPage,
      },
    });
  };

  const handleSelection = function (rowData) {
    dispatch({
      type: "rowSelection",
      payload: {
        selectedRows: rowData.selectedRows,
        allSelected: rowData.allSelected,
      },
    });
  };

  const handleDelete = async (e) => {
    e.preventDefault();

    const token = await getAccessTokenSilently().catch((e) => {
      console.error(e);
      return loginWithRedirect();
    });

    let rowIds = state.selectedRows.map((item) => item._id);
    let { data } = await ai.auth(token).delete("/api/aircrafts/deleteMany", {
      data: { ids: rowIds },
    });

    if (data.deletedCount) {
      getData("", true);

      toast.success("Aircrafts Deleted Successfully", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } else {
      console.log("No Rows Deleted");
    }

    // state changes happen regardless if rows successfully deleted or not
    dispatch({
      type: "rowsDeleted",
    });
  };

  const debouncedGetData = useDebouncedCallback(getData, 500);

  const handleSearch = (e) => {
    let query = e.target.value.toLowerCase();
    dispatch({ type: "search", query });
    debouncedGetData(query);
  };

  return (
    <Fragment>
      {/* <ToastContainer transition={Slide} /> */}

      <PageHeaderRowSearch
        h1={`Aircraft`}
        pretitle="Settings"
        breadcrumbs={[{ link: "/aircraft", label: "Aircraft" }]}
        rightColumn={
          <div
            id="quote-actions-row"
            className="header-actions-row has-delete-btn"
          >
            <Search
              onSearch={handleSearch}
              placeholder="Search Aircraft"
              query={state.query}
            ></Search>
            <TableBulkActions
              state={state}
              handleDelete={handleDelete}
              hideTags
              deleteBtnAlignment={"align-right"}
            />
          </div>
        }
      ></PageHeaderRowSearch>

      <DataTableServerPagination
        onSelection={handleSelection}
        columns={columns}
        handlePageChange={handlePageChange}
        handleRowsPerPageChange={handleRowsPerPageChange}
        state={state}
        data={state.aircrafts.data}
      ></DataTableServerPagination>

      {/* <pre>{JSON.stringify(state, null, 2)}</pre> */}
    </Fragment>
  );
};

export default AircraftsContent;
